import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Box, CircularProgress, Typography, Alert, Button } from "@mui/material";
import AuthService from "../api/axiosInstance";
import endpoints from "../api/endpoints";

export default function VerifyAccountPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({
    loading: true,
    error: null,
    message: null,
  });

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setState({ loading: false, error: "Missing verification token.", message: null });
      return;
    }
    (async () => {
      try {
        const res = await AuthService.post(endpoints.VERIFY_EMAIL, { token });
        setState({
          loading: false,
          error: null,
          message: res?.data?.detail || "Your email has been verified.",
        });
      } catch (err) {
        const detail =
          err?.response?.data?.detail ||
          err?.response?.data?.message ||
          "Verification link is invalid or has expired.";
        setState({ loading: false, error: detail, message: null });
      }
    })();
  }, [searchParams]);

  if (state.loading) {
    return (
      <Box sx={{ minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        maxWidth: 600,
        mx: "auto",
        mt: 4,
        px: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Verify your account
      </Typography>
      {state.error && <Alert severity="error">{state.error}</Alert>}
      {state.message && <Alert severity="success">{state.message}</Alert>}

      <Button variant="contained" onClick={() => navigate("/login")}>
        Go to login
      </Button>
    </Box>
  );
}
